import { forwardRef } from 'react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { Button, type ButtonProps } from '@/components/ui/button'

interface AuthorizedButtonProps extends ButtonProps {
  authorized: boolean
}

export const AuthorizedButton = forwardRef<HTMLButtonElement, AuthorizedButtonProps>(
  ({ authorized, disabled, children, ...props }, ref) => {
    if (!authorized) {
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            {/* span captures pointer events since disabled buttons have pointer-events-none */}
            <span className="inline-flex" tabIndex={-1}>
              <Button ref={ref} disabled {...props}>
                {children}
              </Button>
            </span>
          </TooltipTrigger>
          <TooltipContent>You don't have permission to perform this action</TooltipContent>
        </Tooltip>
      )
    }
    return (
      <Button ref={ref} disabled={disabled} {...props}>
        {children}
      </Button>
    )
  }
)
AuthorizedButton.displayName = 'AuthorizedButton'
